import React from "react"
const FleetIcon = ({ size, className }) => {
    return (
            <svg 
                width={ size }
                height={ size }
                viewBox="0 0 26 26" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className={ className }
            >
                <g id="wind-01">
                    <path 
                        id="Icon" 
                        d="M22.75 19.4998C22.75 19.4998 21.4604 18.9912 20.5833 18.7437C15.0364 17.1787 10.9636 21.821 5.41667 20.2559C4.53961 20.0085 3.25 19.4998 3.25 19.4998M22.75 12.9998C22.75 12.9998 21.4604 12.4912 20.5833 12.2437C15.0364 10.6787 10.9636 15.321 5.41667 13.7559C4.53961 13.5085 3.25 12.9998 3.25 12.9998M22.75 6.49984C22.75 6.49984 21.4604 5.99119 20.5833 5.74374C15.0364 4.17868 10.9636 8.82099 5.41667 7.25594C4.53961 7.00848 3.25 6.49984 3.25 6.49984" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    />
                </g>
            </svg>
    
        )
    }
export default FleetIcon